<template lang="pug">
.institucion(v-if="object")
  span.md-list-item-text {{ object.institucion_afectada }}
    .institucion-info
      .direccion(v-if='object.direccion') {{ object.direccion }}
      .barrio(v-if='object.barrio') {{ object.barrio }}
      div(v-if='object.zona')
        strong Zona:
        span.zona  {{ object.zona }}
      div(v-if='object.distrito')
        strong Distrito:
        span.distrito  {{ object.distrito }}
      div(v-if='object.poblacion_atiende')
        strong Población atendida:
        span.poblacion_atiende  {{ object.poblacion_atiende }}
      div(v-if='object.telefono')
        strong Teléfono:
        span.telefono  {{ object.telefono }}
      div(v-if='object.observacion')
        strong Observación:
        span.observacion  {{ object.observacion }}
      div(v-if='object.sector')
        strong Sector:
        span.sector  {{ object.sector }}
      div(v-if='object.niveles')
        strong Niveles:
        span.niveles  {{ object.niveles }}
      div(v-if='object.tipo')
        strong Tipo:
        span.tipo  {{ object.tipo }}
      div(v-if='object.participacion_comunitaria')
        strong Participación comunitaria:
        span.participacion_comunitaria  {{ object.participacion_comunitaria }}
      div(v-if='object.tiene_internet')
        strong Tiene internet:
        span.tiene_internet  {{ object.tiene_internet }}

</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.institucion
  strong
    font-size: $f14px
  span.md-list-item-text
    font-weight: bold
    .institucion-info
      margin-left: $f10px
      font-weight: normal
      font-size: $f14px
      white-space: normal
</style>
